// extracted by mini-css-extract-plugin
module.exports = {"products":"productSection_products__flw47","title":"productSection_title__1sggR","disclaimer":"productSection_disclaimer__17wd5","containerArrayIsMobile":"productSection_containerArrayIsMobile__37fGi"};
    if(module.hot) {
      // 1790670314771
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  